import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';

@Component({
  selector: 'app-rooms',
  templateUrl: './rooms.component.html',
  styleUrls: ['./rooms.component.css']
})
export class RoomsComponent implements OnInit {
  rooms$;
  constructor(private store: Store<State>) {
    this.rooms$ = store.select(state => state.booking.availableRooms);
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/rooms/rooms.component.ts